import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "signrule" }

import { ref, reactive, onMounted } from 'vue';
import { useApi } from '@/hooks/useApi';
import { ElMessage, ElMessageBox, FormInstance, FormRules } from 'element-plus';
import { useBaseAsync } from 'hpsfir-managebase-ui';
import { SignRuleSpe } from '@/api';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const formRef = ref<FormInstance>();
const saving = ref(false);
const resetting = ref(false);
const loading = ref(false);

const formData = reactive<SignRuleSpe>({
  points: '',
});

// 正整数正则
const positiveIntPattern = /^[1-9]\d*$/u;

const rules: FormRules = {
  points: [
    { required: true, message: '请输入签到奖励积分', trigger: 'change' },
    { pattern: positiveIntPattern, message: '请输入正确的数字', trigger: 'change' },
  ],
};

// 加载配置
const loadConfig = useBaseAsync(async() => {
  loading.value = true;
  try {
    const res = await useApi().signRuleApi.getSignRulesignRule();
    const { data } = res.data;
    if (data) {
      formData.points = data.points || '';
    }
  } finally {
    loading.value = false;
  }
});

// 保存配置
const handleSave = useBaseAsync(async() => {
  await formRef.value?.validate();
  saving.value = true;
  try {
    await useApi().signRuleApi.setSignRulesignRule({
      rule: formData,
    });
    ElMessage.success('保存成功');
  } finally {
    saving.value = false;
  }
});

// 重置为默认
const handleReset = async() => {
  await ElMessageBox.confirm('确定要重置为默认配置吗？', '提示', {
    type: 'warning',
    confirmButtonText: '确认',
    cancelButtonText: '取消',
  });
  resetting.value = true;
  try {
    await useApi().signRuleApi.resetSignRulesignRule();
    ElMessage.success('重置成功');
    await loadConfig();
  } finally {
    resetting.value = false;
  }
};

onMounted(() => {
  loadConfig();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref_key: "formRef",
      ref: formRef,
      model: formData,
      rules: rules,
      "label-width": "150px",
      class: "config-form"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "签到奖励积分",
          prop: "points"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formData.points,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.points) = $event)),
              placeholder: "请输入签到奖励积分"
            }, null, 8, ["modelValue"]),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "form-tip" }, "用户每日签到可获得的积分奖励", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _unref(handleSave),
              loading: saving.value
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" 保存配置 ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick", "loading"]),
            _createVNode(_component_el_button, {
              onClick: handleReset,
              loading: resetting.value
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" 重置为默认 ", -1)
              ]))]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ])), [
    [_directive_loading, loading.value]
  ])
}
}

})